<template>
  <div class="relative">
    <form class="relative" id="search-form" @submit.prevent="toggleSearch">
      <input
        type="search"
        autocomplete="off"
        class="search border border-gray pl-16 pr-8 w-full"
        :class="inputClass"
        v-model="term"
        @focusin="$emit('active')"
        @focusout="$emit('inactive')"
        name="term"
        aria-label="Search Term"
        :placeholder="placeholder">

      <slot name="icon" :toggleSearch="toggleSearch"></slot>
    </form>
    <slot name="result" :term="term"></slot>
  </div>
</template>
<script>

export default {
  props: {
    placeholder: {
      type: String,
      required: true,
    },
    inputClass: {
      type: String,
    },

    defaultValue: {
      default: null,
      type: String,
    }
  },

  data () {
    return {
      term: this.defaultValue,
    }
  },

  methods: {
    toggleSearch () {
      this.$emit('toggled', {term: this.term})
    },
  },

  watch: {
    term (value) {
      this.$emit('updated', {term: value})
    },

    defaultValue (value) {
      this.term = value
    }
  }
}
</script>

<style lang="scss" scoped>
[type="search"]::-webkit-search-cancel-button,
[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
  appearance: none;
}
</style>
